/* eslint-disable max-classes-per-file */

/**
 * @class Base class of API errors.
 *
 * @param {string} message Error message.
 */
function ApiError(message) {
  this.message = message;

  if (typeof Error.captureStackTrace === 'function') {
    Error.captureStackTrace(this, this.constructor);
  } else {
    this.stack = (new Error(message)).stack;
  }
}

ApiError.prototype = Error.prototype;

/* Please keep error classes in alphabetical order. */

/**
 * ArgumentError
 * @extends ApiError
 */
class ArgumentError extends ApiError {}
export { ArgumentError };

/**
 * For APIs need an auth token this error will be returned
 * if token is not set in current API instance.
 * @extends ApiError
 */
class AuthTokenNotSetError extends ApiError {
  constructor() {
    super('auth token is not set');
  }
}
export { AuthTokenNotSetError };

/**
 * Billing errors.
 * @extends ApiError
 */
class BillingError extends ApiError {
  /**
   * @param {string} message
   * @param {Object} payment
   */
  constructor(message, payment = null) {
    super(message);
    this.payment = payment;
  }
}
export { BillingError };

/**
 * EntitlementError
 * @extends ApiError
 */
class EntitlementError extends ApiError {
  /**
   * @param {string} message
   * @param {Object} errors
   */
  constructor(message, errors = null) {
    super(message);
    this.errors = errors;
  }
}
export { EntitlementError };

/**
 * EntitlementPinCodeIncorrect
 * @extends ApiError
 */
export class EntitlementPinCodeIncorrect extends ApiError {}

/**
 * EntitlementPinCodeNotSubmitted
 * @extends ApiError
 */
export class EntitlementPinCodeNotSubmitted extends ApiError {}

/**
 * PaymentRejected error.
 * @extends ApiError
 */
class PaymentRejectedError extends ApiError {}
export { PaymentRejectedError };

/**
 * PayloadToLarge error.
 * @extends ApiError
 */
export class PayloadTooLargeError extends ApiError {}

/**
 * Geoip error.
 * @extends ApiError
 */
class GeoipError extends ApiError {}
export { GeoipError };

/**
 * InvalidCredentialsError
 * @extends ApiError
 */
class InvalidCredentialsError extends ApiError {}
export { InvalidCredentialsError };

/**
 * InvalidInputError
 * @extends ApiError
 */
class InvalidInputError extends ApiError {
  /**
   * @example
   * const err = new InvalidInputError('invalid inputs', {
   *   username: 'too long',
   *   password: 'too short',
   * });
   *
   * @param {string} message Error message.
   * @param {object=} fields Key/value map of error message on each field.
   */
  constructor(message, fields) {
    super(message);
    this.fields = fields;
  }
}
export { InvalidInputError };

/**
 * IdentityUsedError
 * @extends ApiError
 */
class IdentityUsedError extends ApiError {}
export { IdentityUsedError };

/**
 * NotAllowedError
 * @extends ApiError
 */
class NotAllowedError extends ApiError {}
export { NotAllowedError };

/**
 * Generic error when server returns 404 Not Found.
 * @extends ApiError
 */
class NotFoundError extends ApiError {}
export { NotFoundError };

/**
 * Generic error when server returns 401 Unauthorized.
 * @extends ApiError
 */
class UnauthorizedError extends ApiError {}
export { UnauthorizedError };

/**
 * Unknown API error.
 * The error should contain an informativ message that describes what happened
 * and response object if possible.
 * @extends ApiError
 */
class UnknownApiError extends ApiError {
  /**
   * @param {string} [message=unknown api error] Error message.
   * @param {object=} res Response object from superagent.
   */
  constructor(message = 'unknown api error', res) {
    super(message);
    this.res = res;
  }
}
export { UnknownApiError };
